import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { PageTitleService } from '../../core/page-title/page-title.service';

@Component({
  selector: 'app-shell-layout',
  templateUrl: './shell-layout.component.html',
  styleUrls: ['./shell-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet],
})
export class ShellLayoutComponent {
  readonly titleService = inject(PageTitleService);

  @Input() showHeader = true;
}
